import React from 'react';
import ScoreIndicator from '../../shared/ScoreIndicator';

type Props = {
    seoScore: number | undefined;
    isLoading?: boolean;
};

export default function ServiceableUrlsSeoScoreCell({ seoScore, isLoading }: Props) {
    return (
        <>
            {(!isLoading && seoScore && seoScore > 0) ? <ScoreIndicator size="small" value={seoScore} /> : null}
        </>
    );
}
